
import { defineComponent } from 'vue';
import PrzItem from '../AbstractItem/Component.vue';
import PrzPromoCoupon from '../Parts/PromoCoupon/Component.vue';
import PrzElementContent from '../Parts/ContentElement/Component.vue';
import PrzCampaignHtml from '../Parts/CampaignHtml/Component.vue';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockPromo } from '@/models/Blocks/Itens/block-promo';
import { BlockEvents } from '@/models/Blocks/block-events';
export default defineComponent({
    components: {
        PrzItem,
        PrzPromoCoupon,
        PrzElementContent,
        PrzCampaignHtml
    },
    props: {
        item: {
            type: BlockItem,
        }
    },
    computed: {
        promo(): BlockPromo | null {
            return this.item instanceof BlockPromo ? <BlockPromo>this.item : null;
        },
        hasCoupon(): Boolean {
            if (!this.promo) {
                return false;
            }
            if (typeof this.promo.coupon == 'string' || this.promo.coupon instanceof String) {
                return this.promo.coupon && this.promo.coupon != '' ? true : false;
            } else {
                return this.promo.coupon.text && this.promo.coupon.text != '' ? true : false;
            }
        },
        hasCampaingHtml(): boolean {
            return this.promo?.campaign?.content ? true : false;
        },
        hasAction(): boolean {
            return (this.promo?.action ?? null) || this.hasCampaingHtml ? true : false;
        },
        hrefLabel(){
            let text = this.promo?.title.text ?? null;
            return text ? BlockItem.strippedContent(text) : null;
        }
    },
    methods: {
        actionClick() {
            let action = this.promo?.action ?? null;
            if (action) {
                BlockEvents.AddActionBoxClick(this.$el, action);
            }
        }
    }
});
